import { computed, makeObservable } from 'mobx'

import legalEntities from 'modules/core/store/collections/legalEntities'
import type LegalEntity from 'modules/core/store/models/LegalEntity'

import Resource from './Resource'

export interface ITaxonomy {
  [key: string]: unknown
}

class Taxonomy extends Resource {
  static urlRoot() {
    return '/contracts/taxonomies'
  }

  constructor(attr: any = {}) {
    super(attr)
    makeObservable(this, {
      legalEntity: computed,
    })
  }

  get legalEntity(): LegalEntity | null | undefined {
    return legalEntities.get(this.attributes.legal_entity_id)
  }

  get policyTargetClass(): string {
    return '::Contracts::Compensations::Taxonomy'
  }
}

export default Taxonomy
